import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import defaultStyles from './navBarItem.module.scss';

const NavBarItem = ({ styles, ...props }) => (
    <div className={ classnames({
        [styles.navBarItem]: true,
        [styles.active]: props.active,
        [styles.largeFont]: props.largeFont,
        [styles.showHover]: props.showHover
    }) }
    >
        { props.active ? <div className={ styles.navBarItemTab } /> : null }
        <Link className={ styles.navBarItemLink } to={ props.url }>
            { props.icon
                ? (
                    <img
                        src={ props.icon }
                        alt={ props.title }
                        className={ styles.menuIcon }
                    />
                ) : null }
            <br />
            <div className={ styles.label }>{ props.title }</div>
        </Link>
    </div>
);

NavBarItem.propTypes = {
    url: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.string,
    active: PropTypes.bool,
    styles: PropTypes.objectOf(PropTypes.string),
    largeFont: PropTypes.bool,
    showHover: PropTypes.bool
};

NavBarItem.defaultProps = {
    url: '',
    title: '',
    icon: '',
    active: false,
    styles: defaultStyles,
    largeFont: false,
    showHover: false
};

export default NavBarItem;
